import React, { useState } from 'react';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import '../LoginPage/LoginPage.css';
import { useNavigate } from 'react-router-dom';
import { BASE_URL, forgetPassword } from '../../Services/courseService';
import ClipLoader from 'react-spinners/ClipLoader';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import forgot_img from '../../Assets/forgotreset.png'

function ForgotPassword() {
  
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [googleAuthLoading, setGoogleAuthLoading] = useState(false);
  const { t } = useTranslation();

  const handleEmailVerfication = async (e) => {
    e.preventDefault();
    setLoading(true);
    toast.dismiss();

    try {
      const response = await forgetPassword(email);
      if (response?.status === 200) {
        toast.success("Email verified and OTP sent");
        navigate("/resetpassword");
      } else {
        toast.success(response?.data?.message);
      }

    } catch (error) {      
      toast.dismiss();

      if (error?.response?.status === 503) {
        toast.error("Service Unavailable. Please try again later.", { autoClose: 3000 });
      } else {
        toast.error(error.response?.data?.message || 'Network error. Please check your connection and try again.');
      }
    } finally {
      setLoading(false);
    }
  };


  const handleGoogleLogin = async (response) => {
    const token = response.credential;
    toast.dismiss();

    try {
      setGoogleAuthLoading(true);
      const response = await axios.post(`${BASE_URL}/google/login`, { token: token, userType: "Student" });
      if (response?.status === 200) {
        toast.dismiss();

        toast.success("Logged In successfully!", { autoClose: 3000 });
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('fullName', response.data.fullname);
        localStorage.setItem('email', response.data.email);
        localStorage.setItem('userId', response.data.userId);
        localStorage.setItem('userType', response.data.userType);
        localStorage.setItem('profilePictureUrl', response.data.profilePictureUrl);

        navigate('/');
      } else {
        toast.dismiss();

        toast.success(response?.data?.message);
      }

    } catch (error) {
      toast.dismiss();

      if (error?.response?.status === 503) {
        toast.error("Service Unavailable. Please try again later.", { autoClose: 3000 });
      } else {
        toast.error('There was an issue connecting. Please try again, or use normal login/registration.');
      }
    } finally {
      setGoogleAuthLoading(false);
    }
  };


  const handleGoogleLoginFailure = (error) => {
    toast.error('Google login failed. Please try again.', { autoClose: 3000 });
  };

  if (googleAuthLoading) {
    return <div className='loading-container'><div className="loading-overlay">
      <ClipLoader color="black" loading={googleAuthLoading} size={30} />
    </div></div>;
  }
  return (

    <div className='main-login-container'>
      <div className='image-container'>
        <link rel="preload" href={forgot_img} as="image" />

        <img src={forgot_img} alt="Student" className="login-image" />
      </div>
      <div className="login-container">
        <div className="login-form">
          <span className="back-to-login">
            <span style={{ fontSize: '1.9em' }}>&lt;</span>
            <a href="/login">{t('Back to login')}</a>
          </span>
          <h2>{t('Forgot your password?')}</h2>
          <p>{t('Enter your email below to recover your password')}</p>
          <form onSubmit={handleEmailVerfication}>
            <div className="password-input-container">
              <input
                type="text"
                placeholder={t("Email")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>


            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? <ClipLoader color="#fff" loading={loading} size={30} /> : t('Submit')}
            </button>

          </form>

          <div className="divider">
            <hr />
            <span>{t('Or Sign in with')}</span>
            <hr />
          </div>
          <div className="social-icons">
            <div className="google-icon">
              <GoogleLogin
                onSuccess={handleGoogleLogin}
                onFailure={handleGoogleLoginFailure}
                scope="profile email"
                responseType="token id_token"
                useOneTap
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;

